module.exports = __webpack_public_path__ + "static/media/decorator-circle-blue.7e6d8f70.svg";